import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  link: []
};

const slice = createSlice({
  name: 'links',
  initialState,
  reducers: {
    getLink(state, action) {
      state.link = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;

export function setLinks(link) {
  return async (dispatch) => {
    dispatch(slice.actions.getLink(link));
  };
}
